import 'bootstrap';
import lazySizes from 'lazysizes';
import inView from 'in-view';


import './scss/gesellschafterbeschluss-sofort-anfechten.scss';
// import '../../components/font-loader/font-loader';

import '../../components/navi-bootstrap/navi-bootstrap';
import '../../components/smooth-scrolling/smooth-scrolling.js';
import '../../components/intro-image/intro-image.js';

import {
  initSimplePreloader,
  checkAndRemoveSimplePreloader
} from '../../components/preloader/preloader';


// Global Styles
initSimplePreloader({
  windowLoaded: false,
});

window.addEventListener('load',
  () => {
    // $('._brlbs-google-maps img._brlbs-thumbnail').attr('src', window.php_vars.mapImgUri);
    window.fsiPreloader.windowLoaded = true;
    widthFixer();
    checkAndRemoveSimplePreloader()
  });

const widthFixer = () => {
  const targetWidth = $('.fixer').width();
  $('.fixed-inner').css({ width: targetWidth })
}

inView('.navbar')
  .on('enter', () => { $('.fixed-inner').removeClass('transed') })
  .on('exit', () => { $('.fixed-inner').addClass('transed') })


window.lazy = lazySizes

window.addEventListener('resize', () => {
  setTimeout(() => {
    widthFixer()
  }, 450)
});